(function () {
  "use strict";

  /* planaplana: Schreibt die Prägung jeder Buchhülle im Warenkorb zusätzlich als
     Bestell-Zusatzinfo (cart attributes) auf Bestellebene. Diese überleben die
     Bundle-Auflösung und erscheinen dadurch in Shopify-App, Bestellseite und
     (mit passendem E-Mail-Block) in der Bestellbestätigung. Wird bei jedem
     Warenkorb-Wechsel neu aus dem echten Warenkorb aufgebaut, bleibt also synchron. */

  var HANDLES = {
    "buchhuellen-konfigurator": "Kieselleder",
    "buchhullen-konfigurator-leo-textilstoff": "Leo",
    "buchhullen-konfigurator-wildleder": "Wildleder"
  };
  var PREFIX = "Prägung Buchhülle ";
  var MAX = 20;
  var busy = false;

  function optValue(item, name) {
    var arr = item.options_with_values || [];
    for (var i = 0; i < arr.length; i++) {
      if (arr[i].name === name) return arr[i].value;
    }
    return "";
  }

  function propValue(item, key) {
    var p = item.properties || {};
    return p[key] || "";
  }

  function buildValue(item) {
    var material = HANDLES[item.handle] || "";
    var color = optValue(item, "Farbe");
    var orient = propValue(item, "Ausrichtung") || optValue(item, "Ausrichtung");
    var foil = propValue(item, "Farbe der Prägung");
    var l1 = propValue(item, "Prägung Zeile 1");
    var l2 = propValue(item, "Prägung Zeile 2");
    var ausf = optValue(item, "Ausführung");
    var parts = [];
    parts.push(material + (color ? " " + color : ""));
    if (material !== "Kieselleder") {
      parts.push(ausf.indexOf("Schleife") > -1 ? "mit Schleife" : "ohne Schleife");
    }
    if (orient) parts.push(orient);
    if (foil) parts.push("Prägefarbe " + foil);
    var text = l1;
    if (l2) text += (text ? " / " : "") + l2;
    if (text) parts.push("Prägung: " + text);
    return parts.join(" · ");
  }

  function sync() {
    if (busy) return;
    busy = true;
    fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var want = {};
        var n = 0;
        (cart.items || []).forEach(function (item) {
          if (HANDLES[item.handle]) {
            n++;
            want[PREFIX + n] = buildValue(item);
          }
        });
        var attrs = cart.attributes || {};
        var changed = false;
        for (var k in want) { if (attrs[k] !== want[k]) { changed = true; break; } }
        if (!changed) {
          for (var i = n + 1; i <= MAX; i++) { if (attrs[PREFIX + i]) { changed = true; break; } }
        }
        if (!changed) { busy = false; return; }
        var payload = {};
        for (var kk in want) payload[kk] = want[kk];
        for (var j = n + 1; j <= MAX; j++) payload[PREFIX + j] = "";
        return fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ attributes: payload })
        }).then(function () { busy = false; });
      })
      .catch(function () { busy = false; });
  }

  function schedule() { setTimeout(sync, 200); }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", schedule);
  } else {
    schedule();
  }

  ["on:cart:after-add", "cart:refresh", "cart:change", "cart:build", "on:line-item:change", "on:cart-drawer:after-open"].forEach(function (ev) {
    document.addEventListener(ev, schedule);
  });
})();
